import isEmpty from 'lodash.isempty'

import { getPlugin as getTranslationPlugin } from '@i18n/utils'

import {
  PROCESSOUT_ERRORS,
  PROCESSOUT_ERROR_DEFAULT_STRATEGY,
  PROCESSOUT_ERROR_STRATEGIES,
} from '../config/errors'

import translations from './errors.translations'

/**
 * @typedef {Error & Object} ProcessOutError
 * @property {string} code See PROCESSOUT_ERRORS
 * @property {Object} data
 * @property {string} data.origin See PROCESSOUT_ERROR_ORIGINS
 * @property {Object} data.rootError
 * @property {string} data.rootError.message
 * @property {string} data.rootError.code
 * @property {string} data.rootError.stack
 */

/**
 * Create a normalize error, compliant with Error specs.
 * Read more: https://github.com/BackMarket/RFC/blob/master/api/models/API-Model-Error.md
 * @param {string} code
 * @param {Error & { code: string }} [rootError] Original ProcessOut SDK error, if any
 * @param {Object} [data]
 * @returns {ProcessOutError}
 */
export function processOutError(code, rootError = {}, data = {}) {
  const $t = getTranslationPlugin() || (() => {})
  const message =
    $t(translations[code], rootError) ||
    rootError.message ||
    rootError.code ||
    code

  const error = new Error(message)
  error.code = code
  error.data = {
    rootError: {
      message: rootError.message,
      stack: rootError.stack,
      ...rootError,
    },
    ...data,
  }

  return error
}

/**
 * @param {Error} error
 * @returns {boolean} True if one of PROCESSOUT_ERRORS, false otherwise
 */
export function isProcessOutError(error) {
  return (
    !isEmpty(error) &&
    (Object.values(PROCESSOUT_ERRORS.OWN).includes(error.code) ||
      Object.values(PROCESSOUT_ERRORS.SDK).includes(error.code))
  )
}

/**
 * @param {ProcessOutError} error
 * @returns {import('../config/errors').ProcessOutErrorStrategy}
 */
export function processOutErrorStrategy(error) {
  return (
    PROCESSOUT_ERROR_STRATEGIES[error.code] || PROCESSOUT_ERROR_DEFAULT_STRATEGY
  )
}
